import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full bg-white py-16 md:py-24 overflow-hidden" data-id="element-106">
      <div className="max-w-6xl mx-auto px-6" data-id="element-107">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7
        }} className="flex-1 text-center lg:text-left" data-id="element-109">
            <h1 className="text-4xl md:text-5xl lg:text-[3.25rem] font-bold text-teal-900 mb-6 leading-tight" data-id="element-110">
              Recupera tu Agudeza Mental: El Protocolo de 21 Días para Vencer la
              Niebla de la Menopausia
            </h1>

            <h2 className="text-xl md:text-2xl text-gray-700 mb-10 font-light leading-relaxed max-w-2xl lg:max-w-none" data-id="element-111">
              Deja de olvidar palabras en las reuniones y recupera el enfoque de
              tus 30 años sin depender de más café o suplementos mágicos.
            </h2>

            <motion.button onClick={() => {
            document.getElementById('offer-price')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-semibold px-10 py-4 rounded-lg text-lg transition-colors shadow-lg cursor-pointer" data-id="element-112">
              Recupera tu Claridad Mental Ahora
            </motion.button>

            <p className="mt-4 text-sm text-gray-500" data-id="element-113">
              Por Dra. Elena Rojas • Acceso inmediato
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="flex-shrink-0 w-72 md:w-80 lg:w-96" data-id="element-114">
            <div className="relative" data-id="element-115">
              <div className="absolute -inset-4 bg-teal-900/5 rounded-2xl -rotate-2" data-id="element-116" />
              <img src="https://cdn.magicpatterns.com/uploads/fUdKLJEcbMVJ1YQZg6VvMp/menopausia.png" alt="Menopausia Sin Niebla — Una guía para la claridad, la salud y el éxito por Dra. Elena Rojas" className="relative w-full h-auto rounded-lg shadow-2xl" data-id="element-117" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}